
/* injects from baggage-loader */

'use strict';

import ManageProjectController from './manageproject.controller';
import ManageProjectTemplate from './manageproject.html';

export default class ManageProjectComponent {
		constructor() {
				this.templateUrl = ManageProjectTemplate;
				this.controller = ManageProjectController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/manageProject/manageproject.component.js